import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Instagram(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.067 2c1.772.004 2.155.02 3.067.063 1.063.046 1.79.218 2.427.465a4.89 4.89 0 011.77 1.152 4.692 4.692 0 011.145 1.778c.246.632.418 1.363.465 2.425.04.915.055 1.295.058 3.094v2.055c-.003 1.8-.018 2.18-.058 3.094-.047 1.062-.219 1.788-.465 2.425a4.893 4.893 0 01-1.153 1.77 4.88 4.88 0 01-1.77 1.152c-.634.246-1.364.418-2.428.465-.914.04-1.295.055-3.095.058h-2.056c-1.8-.003-2.181-.018-3.096-.058-1.063-.047-1.79-.219-2.427-.465a4.89 4.89 0 01-1.77-1.152 4.88 4.88 0 01-1.157-1.774c-.246-.632-.418-1.363-.465-2.425-.04-.915-.055-1.295-.058-3.094V10.94c.003-1.771.018-2.152.058-3.064.047-1.063.219-1.79.465-2.426a4.896 4.896 0 011.157-1.77 4.875 4.875 0 011.774-1.156c.633-.246 1.364-.418 2.427-.465.991-.043 1.355-.056 3.577-.058h1.608zm-.253 1.802h-1.617c-1.945.002-2.3.016-3.234.058-.973.043-1.504.207-1.856.344a3.136 3.136 0 00-1.15.75 3.102 3.102 0 00-.746 1.149c-.137.351-.301.878-.344 1.855-.044.974-.057 1.32-.059 3.484v1.111c.002 2.163.015 2.507.059 3.484.043.972.207 1.504.344 1.855.183.465.398.797.75 1.149.348.348.684.566 1.15.746.351.137.879.3 1.856.344.974.043 1.32.056 3.486.058h1.112c2.164-.002 2.508-.015 3.485-.058.973-.044 1.505-.207 1.857-.344a3.14 3.14 0 001.149-.75c.348-.348.566-.683.746-1.148.137-.352.301-.879.344-1.856.047-1.051.06-1.371.06-4.04v-.286c-.002-2.406-.014-2.737-.06-3.753-.043-.973-.207-1.503-.344-1.855a3.135 3.135 0 00-.75-1.149 3.097 3.097 0 00-1.149-.746c-.352-.137-.879-.3-1.856-.344-.935-.042-1.289-.056-3.233-.058zM12 7.488a5.138 5.138 0 11-5.137 5.137A5.138 5.138 0 0112 7.488zm0 1.805a3.332 3.332 0 100 6.664 3.332 3.332 0 000-6.664zm5.34-3.207a1.2 1.2 0 110 2.398 1.2 1.2 0 010-2.398z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Instagram);
export default ForwardRef;